import { Container, Text, TextSize } from '@doist/marketist'

import css from './Statement.module.css'

type StatementProps = {
    children: React.ReactNode
    size?: TextSize
}

export function Statement({ children, size = 'major-2xl' }: StatementProps) {
    return (
        <Container width="lg" className={css.statementContainer}>
            <Text tag="h2" size={size} className={css.statementText}>
                {children}
            </Text>
        </Container>
    )
}
